/**
 * Generic response parser for PUT endpoints that return { Success: { message } } on 200.
 * Eliminates duplication across sectionSeparation.ts and sectionMapping.ts.
 */
import { HttpStatus } from './httpStatus';

type SimpleSaveResult = { ok: true; message: string } | { ok: false; message: string };

const extractErrorMessage = (response: any, defaultError: string): string => {
  const successMessage = response?.data?.Success?.message;
  if (typeof successMessage === 'string' && successMessage.trim()) {
    return successMessage;
  }

  const message = response?.data?.message;
  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  if (response?.status) {
    return `${defaultError} (${response.status})`;
  }

  return defaultError;
};

// eslint-disable-next-line import/prefer-default-export
export const resolveSimpleSaveResponse = (
  response: any,
  defaultSuccessMessage: string,
  defaultErrorMessage: string
): SimpleSaveResult => {
  if (!response) {
    return { ok: false, message: 'Unable to reach the server. Please try again.' };
  }

  if (response.status === HttpStatus.OK && response.data?.error !== true) {
    const successMessage = response.data?.Success?.message;
    return {
      ok: true,
      message: typeof successMessage === 'string' ? successMessage : defaultSuccessMessage
    };
  }

  return { ok: false, message: extractErrorMessage(response, defaultErrorMessage) };
};
